// src/content/glossary.js
// Glossary tooltips. Texts are taken from project-context material already in the repo
// (src/config/t4rConfig.js concept descriptions, the MLU catalogue, app/services/connections.py).
// TODO(K8): approve wording; replace with the official definitions from data/concepts/ if preferred.

export const GLOSSARY = {
  mlu: {
    term: "MLU (Micro-Learning Unit)",
    text: "A short, self-contained learning unit from the T4R Train-the-Trainer catalogue (72 units). Each MLU has a title, an EQF level and a learning outcome.",
    source: "MLU catalogue",
  },
  framework: {
    term: "Framework (topic area)",
    text: "The 72 MLUs are grouped into four frameworks: Education, Governance, Technical Design, and Ethics, Inclusion & Democratisation. They structure which MLUs are suggested for which perspective.",
    source: "T4R framework definitions",
  },
  level: {
    term: "Level",
    text: "Within each module, units 1-2 are beginner, 3-4 intermediate and 5-6 expert (advanced) level, following the MLU numbering (e.g. EDU-101 is a beginner unit).",
    source: "MLU numbering convention",
  },
  tripleLoop: {
    term: "Triple-loop learning",
    text: "Connects practice (single loop), strategy (double loop), and underlying assumptions (triple loop) to prioritise MLUs that shift how the organisation learns.",
    source: "Triple-loop learning concept",
  },
  coCreation: {
    term: "Co-creation (Lab-Studio-Arena-Agora)",
    text: "A stakeholder-engagement model that considers where learning happens: experimentation (Lab), co-design (Studio), organisational practice (Arena), and public dialogue (Agora).",
    source: "Co-Creation Model",
  },
  coAgency: {
    term: "Co-agency model",
    text: "Frames how learners, teams, and organisations share responsibility across Learn-Trust-Build-Sustain roles in Local Digital Twin projects.",
    source: "Co-agency model",
  },
  ldt: {
    term: "Local Digital Twin (LDT)",
    text: "A live digital model of a city or region, fed by data, used for better decisions in areas such as mobility, climate and crisis response.",
    source: "T4R project",
  },
};
